import { useSuspenseQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { User } from '@certhon/models';
import { userQueries } from '@/features/users/users.queries';
import useAuthService from '@/hooks/use-auth-service';

export function useUserMap<K extends keyof Pick<User, 'loginname' | 'recnum'>>(
  indexedBy: K = 'recnum' as K,
): Map<User[K], User> {
  const { data: users } = useSuspenseQuery(userQueries.list());
  return useMemo(() => {
    const userMap = new Map<User[K], User>();
    users.forEach((user) => {
      userMap.set(user[indexedBy], user);
    });
    return userMap;
  }, [users, indexedBy]);
}

/**
 * Hook that provides access to the current user state
 */
export function useCurrentUser() {
  const authService = useAuthService();
  return authService.getCurrentUser();
}
